// Loads Clarity + Pinterest tags at runtime from backend config (managed in the admin vault, no rebuild needed)
const API_URL = process.env.REACT_APP_BACKEND_URL;

let loaded = false;

export const loadTrackingTags = async () => {
  if (loaded) return;
  loaded = true;
  try {
    const res = await fetch(`${API_URL}/api/tracking/config`);
    const cfg = await res.json();

    if (cfg.clarity_project_id && !window.clarity) {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', cfg.clarity_project_id);
    }

    if (cfg.pinterest_tag_id && !window.pintrk) {
      (function (e) {
        window.pintrk = function () { window.pintrk.queue.push(Array.prototype.slice.call(arguments)); };
        const n = window.pintrk; n.queue = []; n.version = '3.0';
        const t = document.createElement('script'); t.async = true; t.src = e;
        const r = document.getElementsByTagName('script')[0]; r.parentNode.insertBefore(t, r);
      })('https://s.pinimg.com/ct/core.js');
      window.pintrk('load', cfg.pinterest_tag_id);
      window.pintrk('page');
    }
  } catch (e) {
    // tracking is non-critical
  }
};
